export default "__VITE_ASSET__B2$sZ9Cu__"